import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { useBreakpoint } from "./use-breakpoint";
var DEFAULT_LIMITS = {
  xs: 60,
  sm: 80,
  md: 100,
  lg: 130
};
export var useCharacterLimit = function useCharacterLimit(customLimits) {
  var _useBreakpoint = useBreakpoint(),
    currentBreakpoint = _useBreakpoint.currentBreakpoint;
  var limits = _objectSpread(_objectSpread({}, DEFAULT_LIMITS), customLimits);
  return {
    currentLimit: limits[currentBreakpoint],
    limits: limits
  };
};